import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'eop-highlightor',
  templateUrl: './highlightor.component.html',
  styleUrls: ['./highlightor.component.scss'],
  standalone: false,
})
export class HighlightorComponent implements AfterViewInit, OnChanges {
  @Input() highlight = '';

  @ViewChild('container', { static: true })
  private readonly container!: ElementRef;

  ngAfterViewInit() {
    this.applyHighlightWithDelay();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.highlight) {
      this.applyHighlightWithDelay();
    }
  }

  applyHighlightWithDelay() {
    setTimeout(() => {
      this.clearHighlights();
      if (this.highlight) {
        this.highlightText(this.container.nativeElement, this.highlight);
      }
    }, 300);
  }

  highlightText(element: HTMLElement, text: string) {
    const regex = new RegExp(text, 'gi');

    const walk = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null);

    let node: Text | null;
    while ((node = walk.nextNode() as Text)) {
      if (!node.nodeValue) continue;

      const matches = node.nodeValue.match(regex);
      if (!matches) continue;

      const span = document.createElement('span');
      span.innerHTML = node.nodeValue.replace(regex, `<mark class="highlight">$&</mark>`);

      node.parentNode?.replaceChild(span, node);
    }
  }

  clearHighlights() {
    const marks = this.container.nativeElement.querySelectorAll('mark.highlight');
    marks.forEach((mark: HTMLElement) => {
      mark.replaceWith(document.createTextNode(mark.textContent || ''));
    });
  }
}
